// bm-design-system: list-pill primitive (ported from FloorCore's VendorPill)
// Selectable row for a vertical entity list; active = filled ink with count pill.
import * as React from "react";
import { cn } from "@/lib/utils";

export interface ListPillProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "name"> {
  name: React.ReactNode;
  count?: number;
  active?: boolean;
}

export function ListPill({ name, count, active, className, ...props }: ListPillProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={cn(
        "flex w-full cursor-pointer items-center justify-between gap-3 rounded-lg border px-4 py-3 text-left text-sm font-semibold transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-page",
        active
          ? "border-ink-display bg-ink-display text-page shadow-md"
          : "border-hairline bg-page text-ink-body hover:bg-surface",
        className,
      )}
      {...props}
    >
      {name}
      {typeof count === "number" && (
        <span
          className={cn(
            "rounded-full px-2 py-0.5 text-xs font-bold tabular-nums",
            active ? "bg-accent text-page" : "bg-surface text-ink-muted border border-hairline",
          )}
        >
          {count}
        </span>
      )}
    </button>
  );
}
